import { Component } from '@angular/core';

@Component({
  selector: 'app-achivements-section',
  standalone: true,
  imports: [],
  templateUrl: './achivements-section.component.html',
  styleUrl: './achivements-section.component.css'
})
export class AchivementsSectionComponent {

}
